import { Link } from 'react-router-dom'
import React, { useEffect, useRef, useState } from 'react'
import line from '../../assets/images/anim_line.png'
import blueapp from '../../assets/images/appstore_blue.png'
import blue from '../../assets/images/googleplay_blue.png'
import whiteapp from '../../assets/images/appstore_white.png'
import white from '../../assets/images/googleplay_white.png'
import logo from '../../assets/images/footer_logo.png'
import top from '../../assets/images/go_top.png'
import Goone from "../../assets/images/go_top-one.png"
import Section from '../../assets/images/section-bg.png'
import Shape1 from '../../assets/images/banner-shape-one1.png'
import Shape2 from "../../assets/images/banner-shape2two.png"
import Shape3 from "../../assets/images/banner-shapethree3.png"
import Footerimg from "../../assets/images/footer_logo-one.png"
import Banner1 from '../../assets/images/banner-shape1.png'
import Banner2 from '../../assets/images/banner-shape2.png'
import NexaLogo from '../../assets/images/nexa-logo.png'
import ToolkitPhone from '../../assets/images/nexa-toolkit-phone.png'
import ProductsPhone from '../../assets/images/nexa-products-phone.png'
import Mascot from '../../assets/images/mascot.png'
import PeekingMascot from '../../assets/images/mascot-peeking.png'

const Main = ({ footer }) => {
    const peekingMascotRef = useRef(null)
    const [showPeekingMascot, setShowPeekingMascot] = useState(false)

    useEffect(() => {
        const mascot = peekingMascotRef.current
        if (!mascot) return undefined

        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) {
                setShowPeekingMascot(true)
                observer.unobserve(entry.target)
            }
        }, { threshold: 0.25, rootMargin: '0px 0px -8% 0px' })

        observer.observe(mascot)
        return () => observer.disconnect()
    }, [])

    return (
        <>
            <section className={`newsletter_section ${footer.f1 ? 'nexa-newsletter' : ''}`}>
                <div className="container">
                    <div className="newsletter_box">
                        {footer.f1 && <img ref={peekingMascotRef} className={`newsletter_peeking_mascot${showPeekingMascot ? ' is-peeking' : ''}`} src={PeekingMascot} alt="Nexa mascot peeking over the partner form" />}
                        <div className="section_title" data-aos="fade-in" data-aos-duration="1500" data-aos-delay="100">
                            <h2>Want to be our <span>Partner?</span></h2>
                            <p>Join Nexa and get access to simple protection solutions, updates, and support whenever you need them..</p>
                        </div>
                        <form action="" data-aos="fade-in" data-aos-duration="1500" data-aos-delay="100">
                            <div className="form-group">
                                <input type="email" className="form-control" placeholder="Enter your email" />
                            </div>
                            <div className="form-group">
                                <button className="btn">SUBMIT</button>
                            </div>
                        </form>
                    </div>
                </div>
            </section>

            {footer.f1 &&
                <footer className="nexa-footer">
                    <div className="container footer_download_container">
                        <section className="footer_download_showcase" aria-labelledby="footer-download-title">
                            <div className="footer_contact_panel" data-aos="fade-right" data-aos-duration="1100">
                                <img className="footer_contact_logo" src={NexaLogo} alt="Nexa" />
                                <a href="mailto:asknexa@sample.ph">asknexa@icarenexa.com</a>
                                <Link to="#">02 87776045 | 09175501279</Link>
                                <ul className="footer_contact_socials">
                                    <li><Link to="https://www.facebook.com/profile.php?id=61593170686397" target="_new" aria-label="Facebook"><i className="icofont-facebook"></i></Link></li>
                                    
                                    <li><Link to="#" aria-label="YouTube"><i className="icofont-brand-youtube"></i></Link></li>
                                </ul>
                            </div>
                            <div className="footer_download_copy" data-aos="fade-right" data-aos-duration="1200">
                                <p className="footer_download_eyebrow">Protection in your pocket</p>
                                <h2 id="footer-download-title">Download the App <span>Now</span></h2>
                                <p className="footer_download_text">Manage your protection, explore plans, and get support wherever life takes you.</p>
                                <ul className="footer_store_buttons" aria-label="Download the Nexa app">
                                    <li><Link to="#" aria-label="Download Nexa on the App Store"><img className="blue_img" src={blueapp} alt="Available on the App Store" /><img className="white_img" src={whiteapp} alt="" /></Link></li>
                                    <li><Link to="#" aria-label="Get Nexa on Google Play"><img className="blue_img" src={blue} alt="Get it on Google Play" /><img className="white_img" src={white} alt="" /></Link></li>
                                </ul>
                            </div>
                            <div className="footer_download_visual" data-aos="zoom-in" data-aos-duration="1300">
                                <div className="footer_phone footer_phone_products">
                                    <img src={ProductsPhone} alt="Nexa products app screen" />
                                </div>
                                <div className="footer_phone footer_phone_toolkit">
                                    <img src={ToolkitPhone} alt="Nexa sales toolkit app screen" />
                                </div>
                                <img className="footer_download_mascot" src={Mascot} alt="Nexa mascot" />
                            </div>
                        </section>
                    </div>
                    <div className="top_footer" id="contact">
                        <div className="anim_line dark_bg">
                            <span><img src={line} alt="anim_line" /></span>
                            <span><img src={line} alt="anim_line" /></span>
                            <span><img src={line} alt="anim_line" /></span>
                            <span><img src={line} alt="anim_line" /></span>
                            <span><img src={line} alt="anim_line" /></span>
                            <span><img src={line} alt="anim_line" /></span>
                            <span><img src={line} alt="anim_line" /></span>
                            <span><img src={line} alt="anim_line" /></span>
                            <span><img src={line} alt="anim_line" /></span>
                        </div>
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-4 col-md-6 col-12">
                                    <div className="abt_side">
                                        <div className="logo"> <img src={NexaLogo} alt="Nexa" /></div>
                                        <ul>
                                            <li><a href="mailto:asknexa@sample.ph">asknexa@sample.ph</a></li>
                                            <li><Link to="#">+1-900-123 4567</Link></li>
                                        </ul>
                                        <ul className="social_media">
                                            <li><Link to="#" aria-label="Facebook"><i className="icofont-facebook"></i></Link></li>
                                            <li><Link to="#" aria-label="Instagram"><i className="icofont-instagram"></i></Link></li>
                                            <li><Link to="#" aria-label="YouTube"><i className="icofont-brand-youtube"></i></Link></li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-6 col-12">
                                    <div className="links">
                                        <h3>Useful Links</h3>
                                        <ul>
                                            <li><Link to="/">Home</Link></li>
                                            <li><Link to="/about">About us</Link></li>
                                            <li><Link to="#">Services</Link></li>
                                            <li><Link to="/blog">Blog</Link></li>
                                            <li><Link to="/contact">Contact us</Link></li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-6 col-12">
                                    <div className="links">
                                        <h3>Help & Support</h3>
                                        <ul>
                                            <li><Link to="/faq">FAQs</Link></li>
                                            <li><Link to="#">Support</Link></li>
                                            <li><Link to="/work">How it works</Link></li>
                                            <li><Link to="#">Terms & conditions</Link></li>
                                            <li><Link to="#">Privacy policy</Link></li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-lg-2 col-md-6 col-12">
                                    <div className="try_out">
                                        <h3>Let’s Try Out</h3>
                                        <ul className="app_btn">
                                            <li>
                                                <Link to="#">
                                                    <img src={blueapp} alt="image" />
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="#">
                                                    <img src={blue} alt="image" />
                                                </Link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="bottom_footer">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-6">
                                    <p>© Copyrights 2026. All rights reserved.</p>
                                </div>
                                <div className="col-md-6">
                                    <p className="developer_text">Protection made simple, wherever life takes you.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="go_top">
                        <span><img src={top} alt="image" /></span>
                    </div>
                </footer>
            }

            {footer.f2 &&
                <footer>
                    <div className="top_footer top_footer-dark" id="contact">
                        <div className="container">
                            <span className="banner_shape1"> <img src={Shape1} alt="image" /> </span>
                            <span className="banner_shape2"> <img src={Shape2} alt="image" /> </span>
                            <span className="banner_shape3"> <img src={Shape3} alt="image" /> </span>
                            <div className="row">
                                <div className="col-lg-4 col-md-6 col-12">
                                    <div className="abt_side">
                                        <div className="logo"> <img src={logo} alt="image" /></div>
                                        <ul>
                                            <li><Link to="#">support@example.com</Link></li>
                                            <li><Link to="#">+1-900-123 4567</Link></li>
                                        </ul>
                                        <ul className="social_media">
                                            <li><Link to="#"><i className="icofont-facebook"></i></Link></li>
                                            <li><Link to="#"><i className="icofont-twitter"></i></Link></li>
                                            <li><Link to="#"><i className="icofont-instagram"></i></Link></li>
                                            <li><Link to="#"><i className="icofont-pinterest"></i></Link></li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-6 col-12">
                                    <div className="links">
                                        <h3>Useful Links</h3>
                                        <ul>
                                            <li><Link to="/">Home</Link></li>
                                            <li><Link to="/about">About us</Link></li>
                                            <li><Link to="#">Services</Link></li>
                                            <li><Link to="/blog">Blog</Link></li>
                                            <li><Link to="/contact">Contact us</Link></li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-6 col-12">
                                    <div className="links">
                                        <h3>Help & Suport</h3>
                                        <ul>
                                            <li><Link to="/faq">FAQs</Link></li>
                                            <li><Link to="#">Support</Link></li>
                                            <li><Link to="/work">How it works</Link></li>
                                            <li><Link to="#">Terms & conditions</Link></li>
                                            <li><Link to="#">Privacy policy</Link></li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-lg-2 col-md-6 col-12">
                                    <div className="try_out">
                                        <h3>Let’s Try Out</h3>
                                        <ul className="app_btn">
                                            <li>
                                                <Link to="#">
                                                    <img src={blueapp} alt="image" />
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="#">
                                                    <img src={blue} alt="image" />
                                                </Link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="bottom_footer bottom_footer-dark">
                        <div className="container">

                            <div className="row">
                                <div className="col-md-6">
                                    <p>© Copyrights 2026. All rights reserved.</p>
                                </div>
                                <div className="col-md-6">
                                    <p className="developer_text">Design & developed by <Link to="https://themeforest.net/user/kalanidhithemes" target="blank">Kalanidhi Themes</Link></p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="go_top">
                        <span><img src={top} alt="image" /></span>
                    </div>
                </footer>
            }

            {footer.f3 &&
                <footer className="gredient-footer">
                    <div className="footer_bg"> <img src={Section} alt="image" /> </div>
                    <div className="top_footer" id="contact">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-4 col-md-6 col-12">
                                    <div className="abt_side">
                                        <div className="logo"> <img src={Footerimg} alt="image" /></div>
                                        <ul>
                                            <li><Link to="#">support@example.com</Link></li>
                                            <li><Link to="#">+1-900-123 4567</Link></li>
                                        </ul>
                                        <ul className="social_media">
                                            <li><Link to="#"><i className="icofont-facebook"></i></Link></li>
                                            <li><Link to="#"><i className="icofont-twitter"></i></Link></li>
                                            <li><Link to="#"><i className="icofont-instagram"></i></Link></li>
                                            <li><Link to="#"><i className="icofont-pinterest"></i></Link></li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-6 col-12">
                                    <div className="links">
                                        <h3>Useful Links</h3>
                                        <ul>
                                            <li><Link to="/">Home</Link></li>
                                            <li><Link to="/about">About us</Link></li>
                                            <li><Link to="#">Services</Link></li>
                                            <li><Link to="/blog">Blog</Link></li>
                                            <li><Link to="/contact">Contact us</Link></li>
                                        </ul>
                                    </div>
                                </div>

                                <div className="col-lg-3 col-md-6 col-12">
                                    <div className="links">
                                        <h3>Help & Suport</h3>
                                        <ul>
                                            <li><Link to="/faq">FAQs</Link></li>
                                            <li><Link to="#">Support</Link></li>
                                            <li><Link to="/work">How it works</Link></li>
                                            <li><Link to="#">Terms & conditions</Link></li>
                                            <li><Link to="#">Privacy policy</Link></li>
                                        </ul>
                                    </div>
                                </div>

                                <div className="col-lg-2 col-md-6 col-12">
                                    <div className="try_out">
                                        <h3>Let’s Try Out</h3>
                                        <ul className="app_btn">
                                            <li>
                                                <Link to="#">
                                                    <img src={blueapp} alt="image" />
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="#">
                                                    <img src={blue} alt="image" />
                                                </Link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="bottom_footer">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-6">
                                    <p>© Copyrights 2026. All rights reserved.</p>
                                </div>
                                <div className="col-md-6">
                                    <p className="developer_text">Design & developed by <Link to="https://themeforest.net/user/kalanidhithemes" target="blank">Kalanidhi Themes</Link></p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="go_top">
                        <span><img src={Goone} alt="image" /></span>
                    </div>
                </footer>
            }

            {footer.f4 &&
                <footer className="video-footer-two">
                    <div className="top_footer" id="contact">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-4 col-md-6 col-12">
                                    <div className="abt_side">
                                        <div className="logo"> <img src={logo} alt="image" /></div>
                                        <ul>
                                            <li><Link to="#">support@example.com</Link></li>
                                            <li><Link to="#">+1-900-123 4567</Link></li>
                                        </ul>
                                        <ul className="social_media">
                                            <li><Link to="#"><i className="icofont-facebook"></i></Link></li>
                                            <li><Link to="#"><i className="icofont-twitter"></i></Link></li>
                                            <li><Link to="#"><i className="icofont-instagram"></i></Link></li>
                                            <li><Link to="#"><i className="icofont-pinterest"></i></Link></li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-6 col-12">
                                    <div className="links">
                                        <h3>Useful Links</h3>
                                        <ul>
                                            <li><Link to="/">Home</Link></li>
                                            <li><Link to="/about">About us</Link></li>
                                            <li><Link to="#">Services</Link></li>
                                            <li><Link to="/blog">Blog</Link></li>
                                            <li><Link to="/contact">Contact us</Link></li>
                                        </ul>
                                    </div>
                                </div>

                                <div className="col-lg-3 col-md-6 col-12">
                                    <div className="links">
                                        <h3>Help & Suport</h3>
                                        <ul>
                                            <li><Link to="/faq">FAQs</Link></li>
                                            <li><Link to="#">Support</Link></li>
                                            <li><Link to="/work">How it works</Link></li>
                                            <li><Link to="#">Terms & conditions</Link></li>
                                            <li><Link to="#">Privacy policy</Link></li>
                                        </ul>
                                    </div>
                                </div>

                                <div className="col-lg-2 col-md-6 col-12">
                                    <div className="try_out">
                                        <h3>Let’s Try Out</h3>
                                        <ul className="app_btn">
                                            <li>
                                                <Link to="#">
                                                    <img src={blueapp} alt="image" />
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="#">
                                                    <img src={blue} alt="image" />
                                                </Link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="bottom_footer">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-6">
                                    <p>© Copyrights 2026. All rights reserved.</p>
                                </div>
                                <div className="col-md-6">
                                    <p className="developer_text">Design & developed by <Link to="https://themeforest.net/user/kalanidhithemes" target="blank">Kalanidhi Themes</Link></p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="go_top">
                        <span><img src={Goone} alt="image" /></span>
                    </div>
                </footer>
            }

            {footer.f5 &&
                <footer>
                    <div className="top_footer footer-wave" id="contact">
                        <div className="container">
                            <span className="banner_shape1"> <img src={Banner1} alt="image" /> </span>
                            <span className="banner_shape2"> <img src={Banner2} alt="image" /> </span>
                            <div className="row">
                                <div className="col-lg-4 col-md-6 col-12">
                                    <div className="abt_side">
                                        <div className="logo"> <img src={logo} alt="image" /></div>
                                        <ul>
                                            <li><Link to="#">support@example.com</Link></li>
                                            <li><Link to="#">+1-900-123 4567</Link></li>
                                        </ul>
                                        <ul className="social_media">
                                            <li><Link to="#"><i className="icofont-facebook"></i></Link></li>
                                            <li><Link to="#"><i className="icofont-twitter"></i></Link></li>
                                            <li><Link to="#"><i className="icofont-instagram"></i></Link></li>
                                            <li><Link to="#"><i className="icofont-pinterest"></i></Link></li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-6 col-12">
                                    <div className="links">
                                        <h3>Useful Links</h3>
                                        <ul>
                                            <li><Link to="/">Home</Link></li>
                                            <li><Link to="/about">About us</Link></li>
                                            <li><Link to="#">Services</Link></li>
                                            <li><Link to="/blog">Blog</Link></li>
                                            <li><Link to="/contact">Contact us</Link></li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-6 col-12">
                                    <div className="links">
                                        <h3>Help & Suport</h3>
                                        <ul>
                                            <li><Link to="/faq">FAQs</Link></li>
                                            <li><Link to="#">Support</Link></li>
                                            <li><Link to="/work">How it works</Link></li>
                                            <li><Link to="#">Terms & conditions</Link></li>
                                            <li><Link to="#">Privacy policy</Link></li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-lg-2 col-md-6 col-12">
                                    <div className="try_out">
                                        <h3>Let’s Try Out</h3>
                                        <ul className="app_btn">
                                            <li>
                                                <Link to="#">
                                                    <img src={blueapp} alt="image" />
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="#">
                                                    <img src={blue} alt="image" />
                                                </Link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="bottom_footer">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-6">
                                    <p>© Copyrights 2026© Copyrights 2026. All rights reserved.. All rights reserved.</p>
                                </div>
                                <div className="col-md-6">
                                    <p className="developer_text">Design & developed by <Link to="https://themeforest.net/user/kalanidhithemes" target="blank">Kalanidhi Themes</Link></p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="go_top">
                        <span><img src={top} alt="image" /></span>
                    </div>
                </footer>
            }

        </>
    )
}

export default Main
